export const adminUri = (id: number) => `/users/admin/${id}`;
export const usersRoles = () => '/users/roles';
